import { render, staticRenderFns } from "./invitation_link.vue?vue&type=template&id=15f12adb&scoped=true&"
import script from "./invitation_link.vue?vue&type=script&lang=js&"
export * from "./invitation_link.vue?vue&type=script&lang=js&"
import style0 from "./invitation_link.vue?vue&type=style&index=0&id=15f12adb&prod&lang=css&"
import style1 from "./invitation_link.vue?vue&type=style&index=1&id=15f12adb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f12adb",
  null
  
)

export default component.exports